import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

//import ShareButtons from '../components/ShareButtons';
import MoreGoodies from '../components/more-goodies/MoreGoodies';
import BackToTop from '../components/BackToTop';

// https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
function roundToTwo(num) {
  return +(Math.round(num + 'e+2') + 'e-2');
}

const sensorCropFactors = [
  {
    name: 'Micro Four Thirds',
    cropFactor: 2,
  },
  {
    name: 'Canon APS-C',
    cropFactor: 1.6,
  },
  {
    name: 'Nikon APS-C',
    cropFactor: 1.5,
  },
  {
    name: 'APS-H',
    cropFactor: 1.3,
  },
  {
    name: 'Cropped Medium Format',
    cropFactor: 0.79,
  },
  {
    name: 'Medium Format',
    cropFactor: 0.64,
  },
];

const PageTemplate = css`
.site-main {
background #fff;
padding-bottom: 4vw;
}

.post-content {
max-width: 1000px;
margin: 0 auto;
}
.post-full-content {
  background: transparent;
}
p {
  font-size: 2rem;

}
h2::before {
all: unset !important;
}
h3 {
text-decoration: none !important;
padding-top: 5rem;
text-align: center;
}
`;

const Logo = styled.img`
  width: 150px;
  display: block;
  margin: 0 auto 1.2rem;

  @media (max-width: 650px) {
    width: 100px;
  }
`;

const CalculatorText = styled.p`
  font-size: 4.7rem !important;
  line-height: 1.4;

  border: 5px solid #8000800f;
  border-radius: 16px;
  padding: 3rem 2rem;

  input {
    width: 12rem;
    text-align: center;
    border-radius: 8px;
    border: 1px solid purple;
    padding: 0 0.92rem;
    box-shadow: rgba(39, 44, 49, 0.07) 0px 0px 14px, rgba(39, 44, 49, 0.04) 1px 3px 6px;
  }

  @media (max-width: 600px) {
    font-size: 3.2rem !important;
    padding: 2rem 0.7rem;
    input {
      width: 8rem;
    }
  }

  span {
    text-decoration: rgba(155, 89, 182, 0.3) double underline;
    font-weight: bold;
    color: purple;
  }

  /* https://www.filamentgroup.com/lab/select-css.html */
  select {
    display: inline-block;
    font-size: 18px;
    font-family: sans-serif;
    font-weight: 700;
    line-height: 1.3;
    padding: 0.6em 1.4em 0.5em 0.8em;
    vertical-align: middle;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0;
    border: 1px solid #aaa;
    box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
    border-radius: 0.5em;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),
      linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
    background-repeat: no-repeat, repeat;
    background-position: right 0.7em top 50%, 0 0;
    background-size: 0.65em auto, 100%;
  }
  select::-ms-expand {
    display: none;
  }
  select:hover {
    border-color: #888;
  }
  select:focus {
    border-color: #aaa;
    box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
    box-shadow: 0 0 0 3px -moz-mac-focusring;
    color: #222;
    outline: none;
  }
  select option {
    text-align: center;
    font-weight: normal;
  }
`;

const RememberBox = styled.div`
  margin-top: 15rem;
  background: rgba(155, 89, 182, 0.05);
  border-radius: 8px;
  padding: 1.3rem 1.3rem 0.45rem;

  @media (max-width: 750px) {
    padding: 0.1rem 0.1rem 0.1rem;
  }

  li:first-letter {
    color: rgba(155, 89, 182, 0.3);
  }

  h3 {
    padding-top: 0;
  }
`;

interface CropFactorCalculatorState {
  focalLength: number;
  widestAperture: number;
  cropFactor: number;
}

class CropFactorCalculator extends React.Component<undefined, CropFactorCalculatorState> {
  state = {
    focalLength: 105,
    widestAperture: 1.4,
    cropFactor: 1.5,
  };

  handleFocalChange = evt => {
    if (isNaN(+evt.target.value)) {
      return;
    }
    this.setState({ focalLength: +evt.target.value });
  };

  handleApertureChange = evt => {
    if (isNaN(+evt.target.value)) {
      return;
    }
    this.setState({ widestAperture: evt.target.value });
  };

  handleSelectChange = evt => {
    this.setState({ cropFactor: +evt.target.value });
  };

  render() {
    return (
      <IndexLayout>
        <Helmet>
          <title>Crop Factor Calculator | Giggster Guide</title>
          <meta
            name="description"
            content="Simple online calculator to get the equivalent focal length or maximum aperture of a lens on a cropped or medium format sensor compared to a full-frame sensor."
          />

          <meta property="og:site_name" content="Giggster Guide" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Crop Factor Calculator" />
          <meta
            property="og:description"
            content="Simple online calculator to get the equivalent focal length or maximum aperture of a lens on a cropped or medium format sensor compared to a full-frame sensor."
          />
          <meta property="og:url" content="https://giggster.com/guide/crop-factor-calculator/" />
          <meta
            property="og:image"
            content="https://giggster.com/guide/covers/crop-factor-calculator-cover.jpg"
          />
          <meta property="article:publisher" content="https://www.facebook.com/giggsterHQ" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Crop Factor Calculator" />
          <meta
            name="twitter:description"
            content="Simple online calculator to get the equivalent focal length or maximum aperture of a lens on a cropped or medium format sensor compared to a full-frame sensor."
          />
          <meta name="twitter:url" content="https://giggster.com/guide/crop-factor-calculator/" />
          <meta
            name="twitter:image"
            content="https://giggster.com/guide/covers/crop-factor-calculator-cover.jpg"
          />
          <meta name="twitter:site" content="@Giggster" />
          <meta name="twitter:creator" content="@Giggster" />
        </Helmet>
        <Wrapper css={PageTemplate}>
          <header css={[outer, SiteHeader]}>
            <div css={inner}>
              <SiteNav />
            </div>
          </header>
          <main id="site-main" className="site-main" css={[SiteMain, outer]}>
            <article className="post page" css={[PostFull, NoImage]}>
              <PostFullHeader>
                <PostFullTitle>
                  <Logo
                    src="/guide/images/crop-factor-calculator/crop-factor-calculator-logo.jpg"
                    alt=""
                  />
                  Crop Factor Calculator
                </PostFullTitle>
                <h2 className="b3">
                  Get the full-frame (35mm) equivalent focal length and aperture for different
                  sensor sizes. Just enter the focal length and maximum aperture of your lens and
                  then choose a sensor size.
                </h2>
                {/*<ShareButtons
                  title={'Crop Factor Calculator'}
                  slug={'/crop-factor-calculator/'}
                  imgSrc={'covers/crop-factor-calculator-cover.jpg'}
                />*/}
              </PostFullHeader>

              <PostFullContent className="post-full-content">
                <div className="post-content text-center">
                  <CalculatorText>
                    My{' '}
                    <input
                      type="text"
                      value={this.state.focalLength}
                      onChange={this.handleFocalChange}
                    />
                    mm f/
                    <input
                      type="text"
                      value={this.state.widestAperture}
                      onChange={this.handleApertureChange}
                    />{' '}
                    lens, on a{' '}
                    <select onChange={this.handleSelectChange} value={this.state.cropFactor}>
                      {sensorCropFactors.map(sensor => (
                        <option key={sensor.name} value={sensor.cropFactor}>
                          {sensor.name}
                        </option>
                      ))}
                    </select>{' '}
                    sensor, is equivalent to a{' '}
                    <span>{roundToTwo(this.state.focalLength * this.state.cropFactor)}mm</span>{' '}
                    <span>
                      f/
                      {roundToTwo(this.state.widestAperture * this.state.cropFactor)}
                    </span>{' '}
                    lens. The crop factor for that sensor is <span>{this.state.cropFactor}x</span>.
                  </CalculatorText>

                  <RememberBox>
                    <h3>💡 Useful Info About Crop Factors:</h3>
                    <ul>
                      <li>
                        &#9673; A crop factor is the multiplier that needs to be used to compare the
                        full-frame equivalent focal length and maximum aperture of a lens when used
                        on a different-sized sensor. That means that sensors that are smaller than a
                        full-frame (35mm) sensor will crop out a part of the image that's received
                        by the lens, effectively cropping the image. Calculating the effective focal
                        length using the crop factor therefore allows you to determine the effective
                        field of view for that lens when used on a camera with a smaller sensor.
                      </li>
                      <li>
                        &#9673; In that sense, full-frame sensors are the lingua franca of sensors,
                        meaning that they are the sensor size used as the reference point.
                      </li>
                      <li>
                        &#9673; Larger sensors than full-frame, like medium format sensors, have a
                        reverse crop factor. Cropped medium format sensors include sensors for
                        Pentax and Fujifilm medium format cameras as well as the Hasselblad X1D.
                      </li>
                      <li>
                        &#9673; The crop factor is also used on the aperture to give us the maximum
                        effective aperture equivalent on a full-frame camera. That means that we can
                        have a better idea of the amount of background blur and depth of field that
                        a lens will be able to produce.
                      </li>
                      <li>
                        &#9673; If the topic seems a little confusing or you want to learn more, I
                        recommend{' '}
                        <a href="https://www.youtube.com/watch?v=f5zN6NVx-hY">
                          this video by Tony Northrup
                        </a>
                        .
                      </li>
                    </ul>
                  </RememberBox>
                </div>
              </PostFullContent>
            </article>
            <MoreGoodies slug="crop-factor-calculator" />
          </main>
          <BackToTop />
          <Footer />
        </Wrapper>
      </IndexLayout>
    );
  }
}

export default CropFactorCalculator;
